
import React from "react";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";
import { ScrollArea } from "@/components/ui/scroll-area";
import { FileText, Sparkles } from "lucide-react";

interface AssessmentDrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  assessment: string | null;
  citations: string | null;
  fileName: string;
}

const AssessmentDrawer = ({ open, onOpenChange, assessment, citations, fileName }: AssessmentDrawerProps) => {
  if (!assessment && !citations) return null;

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent className="w-[400px] sm:w-[540px] md:w-[600px] overflow-hidden">
        <SheetHeader>
          <SheetTitle className="flex items-center gap-2">
            <Sparkles className="h-4 w-4" />
            AI Assessment
          </SheetTitle>
          <SheetDescription>
            File: {fileName}
          </SheetDescription>
        </SheetHeader>
        
        <ScrollArea className="h-[calc(100vh-120px)] mt-6 pr-4">
          <div className="space-y-6 pb-4">
            {assessment && (
              <div>
                <h3 className="font-medium mb-2 flex items-center text-primary">
                  <Sparkles className="h-4 w-4 mr-2" />
                  Assessment
                </h3>
                <div className="p-4 bg-muted/50 rounded-md">
                  <p className="text-sm whitespace-pre-line">{assessment}</p>
                </div>
              </div>
            )}

            {citations && (
              <div>
                <h3 className="font-medium mb-2 flex items-center text-blue-600">
                  <FileText className="h-4 w-4 mr-2" />
                  Citations
                </h3>
                <div className="p-4 bg-muted/50 rounded-md">
                  <p className="text-sm whitespace-pre-line">{citations}</p>
                </div>
              </div>
            )}
          </div>
        </ScrollArea>
      </SheetContent>
    </Sheet>
  );
};

export default AssessmentDrawer;
